import {
  useProjectManagerOptionsForUsersQuery,
  useProjectReportOptionsQuery,
} from "@src/__generated__/urql-graphql";
import { useEffect } from "react";
import type { ProjectReportStore } from "./store";

export const useFetchTableOptions = (store: ProjectReportStore) => {
  const [{ fetching: fetchingOptions, data: optionsData }] =
    useProjectReportOptionsQuery();
  const [{ fetching: fetchingAdditionalOptions, data: additionalOptionsData }] =
    useProjectManagerOptionsForUsersQuery();

  useEffect(() => {
    if (!optionsData) return;
    store.setTableOptions(optionsData);
  }, [optionsData]);

  useEffect(() => {
    if (!additionalOptionsData) return;
    store.setTableAdditionalOptions(additionalOptionsData);
  }, [additionalOptionsData]);

  return fetchingOptions && fetchingAdditionalOptions;
};
